<template>
	<div class="w95mg flexcss dn" style="padding-top:20px">
		<div class="fl" style="width: 48%;">
			<div class="land-ecahrt-title">
				<h5 :class="cityInvestType == 1 ? 'current title fl':'title fl'"
					@click="landpiefun(1,curtitle.name1)">{{curtitle.name1}}</h5>
				<h5 :class="cityInvestType == 2 ? 'current title fl':'title fl'"
					@click="landpiefun(2,curtitle.name2)">{{curtitle.name2}}</h5>
			</div>
			<div :id="curtitle.piename" class="echart-line-box" :style="'width:'+echartWidth2+'px;'"></div>
		</div>
		<div class="fr" style="width: 48%;" v-if="showLine">
			<div class="oh land-ecahrt-title">
				<h5 :class="yearInvestType == 1 ? 'current title fl':'title fl'"
					@click="yearInvestLineEchart(1,curtitle.name3)">{{curtitle.name3}}</h5>
				<h5 :class="yearInvestType == 2 ? 'current title fl':'title fl'"
					@click="yearInvestLineEchart(2,curtitle.name4)">{{curtitle.name4}}</h5>
			</div>
			<div :id="curtitle.linename" class="echart-line-box" :style="'width:'+echartWidth2+'px;'"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "parentLinePie",
		data() {
			return {
				title: "最新专利的图表可视化",
				echartWidth2: document.body.offsetWidth * 0.8728 * 0.95 * 0.48,
				cityInvestType: 1,
				yearInvestType: 1,
				cityInvestData: [],
				yearInvestData: [],
				data1: [],
				data2: [],
				data3: [],
				data4: [],
				curtitle: {
					type: 1,
					name1: "专利类型分布",
					name2: "法律状态分布",
					name3: "历年专利申请数量",
					name4: "历年专利公开数量",
					linename: "tzsj-line",
					piename: "tzsj-pie",
					keyword: "数量"
				},
			}
		},
		props: {
			data: {
				type: Object,
				request: true
			},
			detailType: {
				type: Number,
				request: true,
				default: 1
			},
			showPie: {
				type: Boolean,
				request: false,
				default: true
			},
			showLine: {
				type: Boolean,
				request: true,
				default: false
			},
			// pieIdName:{type:String,require:true,default:'nadixinxi-pie'},
			// lineIdName:{type:String,require:true,default:'nadixinxi-line'},
		},
		created() {
			// var list1=this.titlelist.filter(list=>{
			// 	return list.type== this.detailType;
			// });
			// this.curtitle=list1[0];
		},
		mounted() { 
			this.yearInvestLineEchart(1, '历年专利申请数量', '个');
			this.landpiefun(1, '专利类型分布');
		},
		methods: {
			//城市省份分布饼图
			 
			landpiefun(type,title,) {
				this.cityInvestType = type;
				var serdata1 = type == 1 ? this.data.patentByType: this.data.patentByStatus; 
				var mypiechart = echarts.init(document.getElementById(this.curtitle.piename));
				var option = {
					title: {
						text: '',
						left: 20,
						textStyle: {
							fontSize: 16,
							color: "#666"
						},
						top: 10,
					},
					//悬浮显示
					tooltip: {
						trigger: 'item',
						formatter: function(params) {
							// console.log(params)
							let rethtml = params.marker + params.name + " : " + params.value + ' 个';
							return rethtml;
						},
					},
					// color: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
					//图例
					legend: {
						show: false,
						left: 'center',
						bottom: 10,
						itemWidth: 6,
						itemHeight: 6
					},

					series: [{
						name: '',
						type: 'pie',
						radius: '60%',
						data: serdata1,
						label: {
							show: true,
							position: 'outside',
							color: '#000',
							fontSize: 12,
							formatter: '{b}:{d}%',
						},
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				};
				mypiechart.setOption(option);
			},
			sortKey2(array, key) { //正序从小到大
				return array.sort(function(a, b) {
					var x = a[key] * 1;
					var y = b[key] * 1;
					return ((x < y) ? -1 : (x > y) ? 1 : 0)
				})
			},
			//历年今年事件分布 
			yearInvestLineEchart(type1, title, unit) {
				this.yearInvestType = type1;
				var mylinechart = echarts.init(document.getElementById(this.curtitle.linename));
				var xdata = [],
					ydata = [];
				var serdata = type1 == 1 ? this.data.patentByAppDate : this.data.patentByPubDate;
				 
				serdata = this.sortKey2(serdata, 'name');
				for (var n = 0; n < serdata.length; n++) {
					xdata.push(serdata[n].name);
					ydata.push(serdata[n].value);
				}
				var timeunit = '年';
				var yaxirName = this.curtitle.keyword + '（个）'
				// console.log(xdata,ydata); 
				var option = {
					title: {
						text: '',
						left: 'center',
						top: 10,
					},
					color: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
					// tooltip: {
					// 	trigger: 'item'
					// },
					tooltip: {
						trigger: 'item',
						backgroundColor: 'rgba(255,255,255,0.9)',
						borderColor: '#ddd',
						borderWidth: '1',
						textStyle: {
							color: '#000',
							fontSize: 14,
						},
						formatter: function(params) {
							let rethtml = params.marker + params.name + timeunit + title + "：" + params.value +
								unit;
							return rethtml;
						}
					},
					legend: {
						show: true,
						bottom: 10,
					},
					label: {
						show: true
					},
					xAxis: {
						type: 'category',
						data: xdata,
					},
					yAxis: {
						type: 'value',
						name: yaxirName,
					},
					series: [{
						name: '',
						data: ydata,
						type: 'line',
						smooth: true
					}]
				};
				mylinechart.setOption(option);
			},

		}
	};
</script>

<style lang="scss">

</style>